import { CitizenInfo } from "../model/citizen-info";
import { SharedUtils } from "../utilities/shared-utils";
import { EnumLegalEntityRole, LegalEntityInfo } from "./legal-entity-info";
import { Role } from "./role";
import { EnumUserLegalEntityProfile, EnumUserLegalEntityRole, EnumUserRole, UserBasicInfo } from "./user-basic-info";
import { UserLegalEntityAttributesBasicInfo } from "./user-legal-entity-attributes-basic-info";

export class UserInfo extends UserBasicInfo {

    //id: number | undefined;
    //nickname: string | undefined;
    //email: string | undefined;
    //statusId: number | undefined;
    //roles: EnumUserRole[] | undefined;
    //instagramNickname: string | undefined;
    creationDate: Date | undefined;

    citizenInfo: CitizenInfo | undefined;
    userLegalEntitiesAttributesBasicInfo: UserLegalEntityAttributesBasicInfo[] | undefined;
    activeLegalEntityInfo: LegalEntityInfo | undefined;
    userActiveLegalEntityRoles: EnumUserLegalEntityRole[] | undefined;
	userActiveLegalEntityProfile: EnumUserLegalEntityProfile | undefined;

    public override getAuthorities(): Array<Role> {
        
        let rolesList:Set<Role> = new Set<Role>();

        if (this.roles != null && this.roles.length > 0) {
            rolesList = new Set<Role>();
            this.roles.forEach(userRole => {
                rolesList.add(new Role(userRole));
            });
        }

        if (this.activeLegalEntityInfo != undefined && this.activeLegalEntityInfo != undefined &&
            this.activeLegalEntityInfo.roles) {
            this.activeLegalEntityInfo.roles.forEach(legalEntityRole => {
                if (this.userActiveLegalEntityRoles != undefined && this.userActiveLegalEntityRoles.length > 0) {
                    this.userActiveLegalEntityRoles.forEach( (userLegalEntityRole: EnumUserLegalEntityRole) => {
                        rolesList.add(new Role(undefined, legalEntityRole, userLegalEntityRole))
                    });
                } else {
                    rolesList.add(new Role(undefined, legalEntityRole, undefined));    
                }
            });
        }
        console.log(rolesList);
        return Array.from(rolesList);
    }

    public getRolesString(): string {
        let userRoles: string = "";
        if (SharedUtils.inputValueIsPresent(this.roles) && this.roles.length > 0) {
            this.roles.forEach( (role: EnumUserRole) => {
                if (userRoles === "") {
                    userRoles = role.toString() === "NONE" ? userRoles : userRoles.concat(role.toString());
                } else {
                    userRoles = role.toString() === "NONE" ? userRoles : userRoles.concat(", " + role.toString());
                }
            });
        }
        return userRoles;
    }

    public getActiveLegalEntityRolesString(): string {
        let legalEntityRoles: string = "";
        if (SharedUtils.inputValueIsPresent(this.activeLegalEntityInfo) && this.activeLegalEntityInfo?.roles?.length > 0) {
            this.activeLegalEntityInfo?.roles.forEach( (role: EnumLegalEntityRole) => {
                if (legalEntityRoles === "") {
                    legalEntityRoles = role.toString() === "NONE" ? legalEntityRoles : legalEntityRoles.concat(role.toString());
                } else {
                    legalEntityRoles = role.toString() === "NONE" ? legalEntityRoles : legalEntityRoles.concat(", " + role.toString());
                }
            });
        }
        return legalEntityRoles;
    }

    public getUserActiveLegalEntityRolesString(): string {
        let userLegalEntityRoles: string = "";
        if (SharedUtils.inputValueIsPresent(this.userActiveLegalEntityRoles) && this.userActiveLegalEntityRoles.length > 0) {
            this.userActiveLegalEntityRoles.forEach( (role: EnumUserLegalEntityRole) => {
                if (userLegalEntityRoles === "") {
                    userLegalEntityRoles = role.toString() === "NONE" ? userLegalEntityRoles : userLegalEntityRoles.concat(role.toString());
                } else {
                    userLegalEntityRoles = role.toString() === "NONE" ? userLegalEntityRoles : userLegalEntityRoles.concat(", " + role.toString());
                }
            });
        }
        return userLegalEntityRoles;
    }
    
/*****************************
    public setActiveLegalEntityInfo(legalEntityInfo: LegalEntityInfo): void {
        if (SharedUtils.inputValueIsEmpty(legalEntityInfo)) {
            return;
        }
        let newLegalEntityInfo: LegalEntityInfo = new LegalEntityInfo();
        newLegalEntityInfo.id = legalEntityInfo.id;
        newLegalEntityInfo.statusId = legalEntityInfo.statusId;
        newLegalEntityInfo.companyName = legalEntityInfo.companyName;
        newLegalEntityInfo.brandName = legalEntityInfo.brandName;
        newLegalEntityInfo.fiscalCode = legalEntityInfo.fiscalCode;
        newLegalEntityInfo.legalFormId = legalEntityInfo.legalFormId;
        newLegalEntityInfo.vatNumber = legalEntityInfo.vatNumber;
        if (SharedUtils.inputValueIsPresent(legalEntityInfo.roles)) {
            let newRoles: EnumLegalEntityRole[] = new Array<EnumLegalEntityRole>(); 
            legalEntityInfo.roles.forEach ( (enumRole: EnumLegalEntityRole) => {
                newRoles.push(enumRole);
            });
            newLegalEntityInfo.roles = newRoles;
        } else {
            throw new Error("ERROR - UserInfo: Legal Entity Info roles not found:  LegalEntityInfo.legalEntityRoles: " + legalEntityInfo.roles);
        }
        this.activeLegalEntityInfo = new LegalEntityInfo();
        this.activeLegalEntityInfo = newLegalEntityInfo;
    }
***************************/

    public override toString(): string {
        return "USER INFO - id: " + this.id + ", nickname: " + this.nickname +  ", email: " + this.email + 
        ", status id: " + this.statusId +  ", Instagram nickname: " + this.instagramNickname +  ", profiles: " + this.roles + 
        ", Legal entities basic infos: " + this.userLegalEntitiesAttributesBasicInfo;
    }

    /****************
    fromUser(userInfo: this): void {
        this.id = userInfo.id;
        this.nickname = userInfo.nickname;
        this.email = userInfo.email;
        this.statusId = userInfo.statusId;
        this.roles = userInfo.roles;
        this.instagramNickname = userInfo.instagramNickname;        
    }

    ******************/

    getUserBasicInfo(): UserBasicInfo {
        let userBasicInfo: UserBasicInfo = new UserBasicInfo();
        userBasicInfo.id = this.id;
        userBasicInfo.nickname = this.nickname;
        userBasicInfo.email = this.email;
        userBasicInfo.statusId = this.statusId;
        userBasicInfo.instagramNickname = this.instagramNickname;
        return userBasicInfo;
    }

    setBasicInfos(userBasicInfo: UserBasicInfo): void {
        this.id = userBasicInfo.id;
        this.nickname = userBasicInfo.nickname;
        this.email = userBasicInfo.email;
        this.statusId = userBasicInfo.statusId;
        this.roles = userBasicInfo.roles;
        this.instagramNickname = userBasicInfo.instagramNickname;
    }
}
